import { render } from "./ManageUserPage.vue?vue&type=template&id=fb017d0c"
import script from "./ManageUserPage.vue?vue&type=script&lang=js"
export * from "./ManageUserPage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__